<template>
    <main>
        <section>
            <h1>For Reolink customers who have:</h1>
            <ul>
                <li v-for="question in customerQuestions" :key="question">
                    <span class="icon-co_success_blue icon">
                        <span class="path1"/>
                        <span class="path2"/>
                    </span>
                    {{question}}
                </li>
            </ul>
            <reo-common-button
                label="Contact Support for Help"
                :href="config.support_team"
            />
        </section>
        <ul>
            <li>
                <h2>Office Address:</h2>
                <p>{{ address }}</p>
            </li>
            <li>
                <h2>Telephone:</h2>
                <p>+1 888-895-1558 (10:00 AM-7:00 PM EST, Monday to Friday, English service only)</p>
            </li>
            <li>
                <p>
                    Please note: <strong>DO NOT</strong> return items to office address. To return a product, start a <reo-link text="warranty request" :href="config.support_team" :showIcon="false"/> first.
                    If you have any questions about our <reo-link text="Privacy Policy" :href="config.privacy" :show-icon="false"/>, or request your personal data, you can contact us at dpo#reolink.com (replace # with @).
                </p>
            </li>
        </ul>
    </main>
</template>

<script lang="ts">
import nProgress from 'nprogress';
import Vue from 'vue';
import ReoLink from '@/basic/Link.vue';
import { config } from 'CONFIG';
import { productsManager } from '@/lib';

export default Vue.extend({
    components: {
        ReoLink
    },
    data() {

        return {
            config,
            inAmerica: true,
        };

    },
    computed:{
        address(): string {

            return this.inAmerica ? '13668 Valley Blvd Unit C1, City of industry, CA, United States(EZTECHDIGITAL INC.)'
                : 'FLAT/RM 705 7/F, Fa Yuen Commercial Building 75-77, Fa Yuen Street, Mong KoK, KL, Hong Kong';

        },
        customerQuestions(): string[] {

            return [
                'any technical issues while using our products or services',
                'any payment or delivery problems while placing your orders',
                'any feature suggestions',
                'any other concerns'
            ];

        }
    },
    async created() {

        await productsManager.update({});
        this.inAmerica = ['US', 'CA'].includes( productsManager.getDefaultCountryKey() ?? '' );

    },
    mounted() {

        nProgress.done();

    }
});
</script>

<style lang="less" scoped>
main{
    margin: 0 auto;
    max-width: 1200px;
    padding: 60px 0;
    min-height: calc(100vh - 447px);
    .mobile({
        padding: 20px;
    });
    ul{
        display: flex;
        flex-direction: column;
        gap: 32px;
        li{
            h1{
                font-size: 16px;
                font-weight: 600;
                line-height: 30px;
            }
            p{
                color: @font_secondary;
                font-size: 16px;
                line-height: 30px;
                font-weight: 500;
                /deep/ .ui-link{
                    display: inline-flex;
                    vertical-align: baseline;
                    .text{
                        font-size: 16px;
                        line-height: 30px;
                        font-weight: 500;
                    }
                }
            }
        }
    }
    section{
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        margin-bottom: 24px;
        h1{
            font-size: 32px;
            font-weight: 600;
            color: @b_6;
        }
        ul{
            display: flex;
            flex-direction: column;
            gap: 24px;
            li{
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: 500;
                gap: 6px;
                .icon{
                    font-size: 20px;
                }
            }
        }
    }
}
</style>
